// Tween / 銷毀共用工具
// 多個動畫元件（CFlowerBanner / CTenpaiBanner / CTenpaiPeek …）的銷毀都是同一套
// 「先 killTweensOf 子物件，再 destroy」樣板，各自手寫。抽成共用函式避免遺漏 killTweensOf
// 造成殘留 tween 操作已銷毀物件。
//
// === 使用圖片 ===
// 無 — 純 tween / 物件生命週期邏輯，不建立任何顯示物件

import type Phaser from 'phaser';

/** 停掉每個物件上所有 tween 後 destroy（給「沒有容器、各自獨立」的 sprite 用）。 */
export const killAndDestroy = (
  scene: Phaser.Scene,
  ...objects: Array<Phaser.GameObjects.GameObject | null | undefined>
): void => {
  for (const obj of objects) {
    if (!obj) continue;
    scene.tweens.killTweensOf(obj);
    obj.destroy();
  }
};

/**
 * 停掉容器與其所有子物件上的 tween 後 destroy(true)（連同子物件一併銷毀）。
 * Container.destroy(true) 會銷毀子物件，但不會自動 kill 子物件上的 tween，故先逐一 kill。
 */
export const killAndDestroyContainer = (
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container | null | undefined
): void => {
  if (!container) return;
  for (const child of container.list) scene.tweens.killTweensOf(child);
  scene.tweens.killTweensOf(container);
  container.destroy(true);
};
